import React from "react"
import { useContext } from "react"
import { Context } from "../../store/store"
import ElemInput from "../elements/Input"
import ElemSelect from "../elements/Select"

interface PersonProps {
	formElementChanged: Function
	validation: Object
}
const Person: React.FC<PersonProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)

	return (
		<section className="mx-auto mt-8 max-w-[900px] px-6 md:mt-0 md:px-0">
			<h2 className="mb-4 text-center  font-Alpro text-[32px] text-white ">Persönliche Angaben</h2>
			<div className="mx-auto grid grid-cols-1 md:grid-cols-2 ">
				<div className="md:max-w-[50%]">
					<ElemSelect
						label={"Anrede"}
						props={{
							type: "text",
							name: "salutation",
							value: globalState.salutation || 4,
							minLength: 1,
							onChange: e => formElementChanged(e, "salutation"),
						}}
						hasError={validation["invalid_salutation"] ? true : false}
						className={"max-w-[200px] " + (globalState.salutation === 4 ? "text-lightgray" : "text-black")}
						errMsg={validation["invalid_salutation_errMsg"] || "Bitte Vornamen eingeben."}
					>
						<option value="4" className="text-lightgray">
							Anrede
						</option>
						<option value="1">Herr</option>
						<option value="2">Frau</option>
						<option value="3">Divers</option>
					</ElemSelect>
				</div>
				<div className="hidden md:block"></div>
			</div>
			<div className="mx-auto grid  grid-cols-1 items-start lg:grid-cols-[1fr_1fr] lg:gap-6">
				<ElemInput
					label={"Vorname*"}
					props={{
						type: "text",
						name: "firstname",
						value: globalState.firstname,
						required: "required",
						minLength: 1,
						placeholder: "Vorname*",
						onChange: e => formElementChanged(e, "firstname"),
					}}
					hasError={validation["invalid_firstname"] ? true : false}
					className=""
					errMsg={validation["invalid_firstname_errMsg"] || "Bitte gib deinen Vornamen an."}
				/>
				<ElemInput
					label={"Nachname*"}
					props={{
						type: "text",
						name: "surname",
						value: globalState.surname,
						required: "required",
						minLength: 1,
						placeholder: "Nachname*",
						onChange: e => formElementChanged(e, "surname"),
					}}
					hasError={validation["invalid_surname"] ? true : false}
					className="col-span-2 lg:col-span-1"
					errMsg={validation["invalid_surname_errMsg"] || "Bitte gib deinen Nachnamen an."}
				/>
			</div>
			<div className="">
				<ElemInput
					label={"E-Mail-Adresse*"}
					props={{
						type: "text",
						name: "email",
						value: globalState.email,
						required: "required",
						minLength: 1,
						placeholder: "E-Mail-Adresse*",
						onChange: e => formElementChanged(e, "email"),
					}}
					hasError={validation["invalid_email"] ? true : false}
					className="col-span-2 lg:col-span-1"
					errMsg={validation["invalid_email_errMsg"] || "Bitte gib deine E-Mail-Adresse an."}
				/>
			</div>
			<div className="w-full">
				<ElemSelect
					label={"Produkt*"}
					props={{
						type: "text",
						name: "product",
						value: globalState.product,
						required: "required",
						minLength: 1,
						onChange: e => formElementChanged(e, "product"),
					}}
					hasError={validation["invalid_product"] ? true : false}
					className={""}
					errMsg={validation["invalid_product_errMsg"] || "Bitte gib dein gekauftes Produkt an."}
				>
					<option value="" className="text-lightgray" disabled>
						bitte wählen
					</option>
					<option value="a">Alpro®- Soja-Joghurtalternative Natur, 400g</option>
					<option value="b">Alpro®- Soja-Joghurtalternative Natur mit Mandeln, 400g</option>
					<option value="c">Alpro®- Soja-Joghurtalternative Natur mit Kokosnuss, 400g</option>
					<option value="d">Alpro®- Soja-Joghurtalternative Natur mit Hafer, 400g</option>
					<option value="e">Alpro®- Soja-Joghurtalternative Hafer+ Natur, 400g</option>
					<option value="f">Alpro®- Soja-Joghurtalternative Natur Ohne Zucker, 400g</option>
					<option value="g">Alpro®- Soja-Joghurtalternative This is not Y*gurt, 400</option>
					<option value="h">Alpro®- Soja-Joghurtalternative Heidelbeere, 400</option>
					<option value="i">Alpro®- Soja-Joghurtalternative Vanille, 400g</option>
					<option value="j">Alpro®- Soja-Joghurtalternative Pfirsich, 400g</option>
					<option value="k">Alpro®- Soja-Joghurtalternative Kirsche, 400</option>
					<option value="l">Alpro®- Soja-Joghurtalternative Zitrone-Limette, 400g</option>
					<option value="m">Alpro®- Soja-Joghurtalternative Erdbeere, 400g</option>
					<option value="n">Alpro®- Soja-Joghurtalternative Erdbeere Banane, 400g</option>
					<option value="o">Alpro®- Soja-Joghurtalternative Mango ohne Zuckerzusatz, 400g</option>
					<option value="p">Alpro®- Soja-Joghurtalternative Ananas-Passionsfrucht ohne Zuckerzusatz, 400</option>
					<option value="q">Alpro®- Soja-Joghurtalternative Himbeere-Apfel ohne Zuckerzusatz, 400g</option>
					<option value="r">Alpro®- Soja-Joghurtalternative Rote Früchte mit Datteln ohne Zuckerzusatz, 400</option>
					<option value="s">Alpro®- Soja-Joghurtalternative Dessert Style Apfelstrudel Geschmack, 400</option>
					<option value="t">Alpro®- Soja-Joghurtalternative Dessert Style Lemon-Cheesecake Geschmack, 400</option>
					<option value="u">Alpro®- Soja-Joghurtalternative Dessert Style Blueberry Muffin Geschmack, 400g</option>
					<option value="v">Alpro®- Soja-Joghurtalternative Skyr Natur ohne Zucker, 400g</option>
					<option value="w">Alpro®- Soja-Joghurtalternative Skyr Vanille, 400g</option>
					<option value="x">Alpro®- Soja-Joghurtalternative Skyr Mango, 400g</option>
				</ElemSelect>
			</div>
		</section>
	)
}

export default Person
